<template>
    <component :is="resolved" v-if="resolved" v-bind="$attrs" />
</template>
<script>
import { iconMap } from '@/icons.js';

// Drop-in replacement for @iconify/vue's <Icon icon="collection:name" />, but
// resolving from the offline bundle (icons.js) instead of the iconify API.
// Registered globally as "Icon" in main.js, so existing usages need no changes.
export default {
    name: 'Icon',
    inheritAttrs: false,
    props: { icon: { type: String, required: true } },
    computed: {
        resolved() {
            var component = iconMap[this.icon];
            if (!component && import.meta.env.DEV) {
                console.warn('Icon not in offline bundle (add it to icons.js):', this.icon);
            }
            return component;
        }
    }
}
</script>
